var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { TableHeading } from '@/typings';
import { TYPES } from '@/dependency-injection/types';
import BaseTable from '@/components/base/BaseTable.vue';
import TableMixin from '@/mixins/table-mixin';
import ItemsMixin from '@/mixins/items-mixin';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import PromptDialog from '@/components/shared/PromptDialog.vue';
import OpportunityTableRow from '@/pages/opportunity-management/shared/OpportunityTableRow.vue';
import OpportunityItem from '@/pages/opportunity-management/shared/OpportunityItem.vue';
var OpportunityTable = /** @class */ (function (_super) {
    __extends(OpportunityTable, _super);
    function OpportunityTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultTableHeadings = [
            new TableHeading('Market', 'marketId'),
            new TableHeading('Index', 'plattsRegion'),
            new TableHeading('Site', 'siteId'),
            new TableHeading('Load ID', 'loadId'),
            new TableHeading('Material', 'materialId'),
            new TableHeading('Load Size<br/><small>Gallons</small>', 'loadSize'),
            new TableHeading('Time Window', 'timeWindowStart'),
            new TableHeading('Source Type', 'sourceType'),
            new TableHeading('Source', 'vendorId'),
            new TableHeading('Load<br/>Status', 'loadStatus'),
            new TableHeading('Opportunity<br/>Status', 'loadOpportunityStatus'),
            new TableHeading('Dispatch Desk Name', 'dispatchDeskName'),
            new TableHeading('Actions', 'id', false, '150px'),
            new TableHeading('Modified', 'modDate'),
        ];
        _this.pagination = {
            descending: true,
            page: 1,
            rowsPerPage: 10,
            sortBy: 'loadId',
            totalItems: 0,
        };
        return _this;
    }
    OpportunityTable.prototype.beforeMount = function () {
        this.serviceSymbol = TYPES.OpportunityService;
    };
    // market, site, load
    OpportunityTable.prototype.customSearchFilter = function (value, search, item) {
        search = search.toLowerCase();
        return ((item.siteId && item.siteId.toLowerCase().includes(search)) ||
            (item.siteName && item.siteName.toLowerCase().includes(search)) ||
            (item.loadId && item.loadId.toLowerCase().includes(search)) ||
            (item.voyageId && item.voyageId.toLowerCase().includes(search)) ||
            (item.materialId && item.materialId.toLowerCase().includes(search)) ||
            (item.materialName && item.materialName.toLowerCase().includes(search)) ||
            (item.dispatchDeskId && item.dispatchDeskId.toLowerCase().includes(search)) ||
            (item.dispatchDeskName && item.dispatchDeskName.toLowerCase().includes(search)) ||
            (item.carrierId && item.carrierId.toLowerCase().includes(search)) ||
            (item.carrierName && item.carrierName.toLowerCase().includes(search)) ||
            (item.carrierGroupId && item.carrierGroupId.toLowerCase().includes(search)) ||
            (item.carrierGroupName && item.carrierGroupName.toLowerCase().includes(search)) ||
            (item.sourceType && item.sourceType.toLowerCase().includes(search)) ||
            (item.vendorId && item.vendorId.toLowerCase().includes(search)) ||
            (item.vendorName && item.vendorName.toLowerCase().includes(search)) ||
            (item.marketId && item.marketId.toLowerCase().includes(search)) ||
            (item.timeWindowStart && item.timeWindowStart.toLowerCase().includes(search)) ||
            (item.timeWindowEnd && item.timeWindowEnd.toLowerCase().includes(search)) ||
            (item.timeWindowStart && item.timeWindowEnd && (item.timeWindowStart + '-' + item.timeWindowEnd).includes(search)) ||
            (item.loadStatus && item.loadStatus.toLowerCase().includes(search)) ||
            (item.loadOpportunityStatus && item.loadOpportunityStatus.toLowerCase().includes(search)) ||
            (item.loadSize && item.loadSize.toString().toLowerCase().includes(search)));
    };
    Object.defineProperty(OpportunityTable.prototype, "tableHeadings", {
        get: function () {
            if (this.isActionsTable) {
                return this.defaultTableHeadings.filter(function (heading) { return heading.value !== 'marketId' && heading.value !== 'plattsRegion' && heading.value !== 'siteId'; });
            }
            else if (!this.showIndexColumn) {
                return this.defaultTableHeadings.filter(function (heading) { return heading.value !== 'plattsRegion'; });
            }
            else {
                return this.defaultTableHeadings;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityTable.prototype, "loads", {
        get: function () {
            return this.isActionsTable
                ? this.opportunityLoads
                : this.items;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: Boolean, required: false, default: true }),
        __metadata("design:type", Boolean)
    ], OpportunityTable.prototype, "isActionsTable", void 0);
    __decorate([
        Prop({ type: String, required: false, default: 'loadId' }),
        __metadata("design:type", String)
    ], OpportunityTable.prototype, "itemKey", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], OpportunityTable.prototype, "loadingOpportunities", void 0);
    __decorate([
        Prop({ type: Array, required: false, default: function () { return []; } }),
        __metadata("design:type", Array)
    ], OpportunityTable.prototype, "opportunityLoads", void 0);
    __decorate([
        Prop({ type: Array, required: false, default: function () { return []; } }),
        __metadata("design:type", Array)
    ], OpportunityTable.prototype, "availableActions", void 0);
    __decorate([
        Prop({ type: Boolean, required: true }),
        __metadata("design:type", Boolean)
    ], OpportunityTable.prototype, "showIndexColumn", void 0);
    OpportunityTable = __decorate([
        Component({
            components: {
                'base-table': BaseTable,
                'prompt-dialog': PromptDialog,
                'opportunity-table-row': OpportunityTableRow,
                'opportunity-item': OpportunityItem,
            },
        })
    ], OpportunityTable);
    return OpportunityTable;
}(Mixins(TableMixin, SnackbarMixin, ItemsMixin)));
export default OpportunityTable;
